import {useState} from 'react';
import {useSetRecoilState} from 'recoil';
import {valuesToSendMagicLinkState, valuesToLoginMagicLinkState} from '../helpers/auth';
import {sendMagicLinkQuery, magicLinkLoginQuery, userQuery} from '../queries/auth';
import {session} from '../states/session';
import {MagicLinkBodyT} from '../types/auth';
import {setToken} from './auth';

export type useSendMagicLinkRes = {
  onSend: (values: any) => void;
  success?: boolean;
  error?: string;
};

export const useSendMagicLink = (onSuccess?: () => void): useSendMagicLinkRes => {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | undefined>('');
  const onSend = async (values: any) => {
    try {
      setError('');
      setSuccess(false);

      const body = valuesToSendMagicLinkState(values);
      const res = await sendMagicLinkQuery(body);
      if (res.status) {
        onSuccess?.();
        setSuccess(true);
      }
    } catch (e) {
      setError("That email doesn't seem to be available in our system.");
    }
  };
  return {onSend, success, error};
};

export type useLoginMagicLinkRes = {
  onLogin: (values: MagicLinkBodyT) => void;
  success?: boolean;
  error?: string;
};

export const useLoginMagicLink = (redirect?: () => void): useLoginMagicLinkRes => {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | undefined>('');
  const setSession = useSetRecoilState(session);

  const onLogin = async (values: MagicLinkBodyT) => {
    try {
      setError('');
      setSuccess(false);

      const body = valuesToLoginMagicLinkState(values);
      const res = await magicLinkLoginQuery(body);
      if (res.status) {
        const token = res.body?.id_token;
        setToken(token);
        const currentUser = await userQuery();
        setSession({sessionToken: token, user: currentUser.body});
        setSuccess(true);
        redirect?.();
      }
    } catch (e) {
      console.log(e);
      setError('Login error');
      redirect?.();
    }
  };
  return {onLogin, success, error};
};
